/**
* Before and After Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Before and After Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {
    className: 'before-and-after-slider',
    selector: function() {
      return '.' + this.className;
    },

    init: function() {
      const $slider = $( '.before-after-slider-outer' );

      $slider.slick( {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      } );

      $( '.before-after__prev' ).on( 'click', function() {
        $slider.slick( 'slickPrev' );
      } );

      $( '.before-after__next' ).on( 'click', function() {
        $slider.slick( 'slickNext' );
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'before-and-after-slider', COMPONENT );
} )( app );
